import { defineStore } from "pinia";
import axiosInstance from "../config/axios";

export const usePriceStore = defineStore("price", {
    state: () => {
        return {
            cheapestPricesData: [],
            moreExpensivePricesData: [],
            mostExpensivePricesData: [],
            page: 1,
            perPage: 10,
            pricesLoading: false,
        };
    },
    getters: {},
    actions: {
        async fetchCheapestPrices({ shopId, data }) {
            return axiosInstance
                .get(`/v1/price-report/cheapest-prices/${shopId}`, { params: data })
                .then((response) => {
                    this.cheapestPricesData = response.data;
                });
        },
        async fetchMoreExpensivePrices({ shopId, data }) {
            return axiosInstance
                .get(`/v1/price-report/more-expensive-prices/${shopId}`, { params: data })
                .then((response) => {
                    this.moreExpensivePricesData = response.data;
                });
        },
        async fetchMostExpensivePrices({ shopId, data }) {
            return axiosInstance
                .get(`/v1/price-report/most-expensive-prices/${shopId}`, { params: data })
                .then((response) => {
                    this.mostExpensivePricesData = response.data;
                });
        },
    },
});
